<template>
  <div>
    <el-form ref="searchForm" :inline="true" class="" :model="searchForm">
      <el-form-item label="代理商编码:" prop="orderUnitCode" clearable>
        <el-input v-model.trim="searchForm.orderUnitCode" placeholder="请输入代理商编码" />
      </el-form-item>
      <el-form-item label="代理商名称:" prop="orderUnit" clearable>
        <el-input v-model.trim="searchForm.orderUnit" placeholder="请输入代理商名称" />
      </el-form-item>
      <el-form-item label="区域:" prop="regionName">
        <el-input v-model="searchForm.regionName" placeholder="请输入区域" />
      </el-form-item>

      <el-form-item label="年度:" prop="year">
        <el-select
          v-model="searchForm.year"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="option in year"
            :key="option.name"
            :label="option.name"
            :value="option.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="月份:" prop="month">
        <el-select
          v-model="searchForm.month"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="option in month"
            :key="option.name"
            :label="option.name"
            :value="option.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="是否有应收款:" prop="receivable">
        <el-select
          v-model="searchForm.receivable"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="option in receivable"
            :key="option.name"
            :label="option.name"
            :value="option.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="isLoading" @click="doSearch">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="isLoading" class="tableClass" :data="tableData" border style="width: 100%">
      <el-table-column type="index" width="60" label="序号" align="left" fixed="left" />
      <el-table-column prop="orderUnitCode" label="代理商编码" align="left" fixed="left" />
      <el-table-column prop="orderUnit" label="代理商名称" align="left" />
      <el-table-column prop="regionName" label="区域" align="left" />
      <el-table-column prop="year" label="年度" align="left" />
      <el-table-column prop="month" label="月份" align="left" />
      <el-table-column prop="receivable" label="是否有应收款" align="left">
        <template v-slot="{row}">
          <span>{{ row.receivable?"是":"否" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="对账单" align="left" width="200" fixed="right">
        <template v-slot="{row}">
          <el-button type="text" @click="accountbill(row)">
            对账单附件
          </el-button>
          <!-- <el-button type="text" style="margin-top:20px" v-if="row.receivable">查看对账单</el-button> -->
          <el-button type="text" @click="check(row)">
            查看对账单
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right;margin-top: 10px">
      <el-pagination
        :page-sizes="[10]"
        :page-size.sync="page.pageSize"
        :current-page.sync="page.currentPage"
        layout="total, prev, pager, next, jumper,sizes"
        :total="page.total"
        hide-on-single-page
        @size-change="handerSizeChange"
        @current-change="handerCurrentChange"
      />
    </div>
    <a ref="downTag" :href="fileserveDownUrl" target="_blank" />
    <el-dialog title="对账单查看" :visible.sync="openVisible" @close="closeLog" @open="open">
      <el-table v-loading="isTableLoading" :data="fileData" border style="width: 100%">
        <el-table-column prop="fileName" label="文件名称" align="left">
          <template v-slot="{row}">
            <el-button type="text" @click="openContract(row.fileToken)">
              {{ row.fileName }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="createName" label="上传人" align="left" />
        <el-table-column prop="createTime" label="上传时间" align="left" width="160" />
        <el-table-column prop="pname" label="操作" align="left" width="120">
          <template v-slot="{row}">
            <el-button type="text" @click="downOneFile(row.fileToken)">
              下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { selectByCondition, getUrlByFileID, selectAttachmentByAccountStatementId, attachmentGetToken } from '@/API';

export default {
  computed: {
    ...mapState({
      year: state => state.enumeration.year,
      month: state => state.enumeration.mounth

    })
  },
  data () {
    return {
      searchForm: {
        orderUnitCode: '',
        orderUnit: '',
        regionName: '',
        year: '',
        month: '',
        receivable: true
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      isLoading: false,
      tableData: [],
      fileData: [],
      isTableLoading: false,
      openVisible: false,
      rowData: {},
      downFileUrl: '',
      token: '',
      fileserveDownUrl: '',
      receivable: [{ name: '全部', code: '' }, { name: '是', code: true }, { name: '否', code: false }]
    };
  },
  methods: {
    resetForm () {
      this.$refs.searchForm.resetFields();
      this.page.currentPage = 1;
      this.doSearch();
    },
    doSearch () {
      this.isLoading = true;
      let parmas = { ...this.searchForm, pageIndex: this.page.currentPage, pageSize: this.page.pageSize };
      selectByCondition(parmas).then((res) => {
        const json = res.data;
        this.isLoading = false;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
        }
      }).catch(() => {
        this.isLoading = false;
      });
    },
    handerSizeChange () {
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange () {
      this.doSearch();
    },
    // 查看对账单
    check (row) {
      this.$router.push({ name: 'checkManagement', query: { userId: row.orderUnitCode, userName: row.orderUnit } });
    },
    accountbill (row) {
      this.rowData = row;
      this.openVisible = true;
    },
    open () {
      this.initToken();
      selectAttachmentByAccountStatementId({ accountStatementId: this.rowData.id }).then((res) => {
        const json = res.data;
        this.isLoading = false;
        if (json.status === '200') {
          this.fileData = json.data;
        }
      }).catch(() => {
        this.isLoading = false;
      });
    },
    initToken () {
      attachmentGetToken().then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch(() => {

      });
    },
    closeLog () {
      this.openVisible = false;
    },
    downOneFile (id) {
      this.fileserveDownUrl = this.downFileUrl + `/${id}?Token=${this.token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    },
    openContract (fileCode) {
      getUrlByFileID(fileCode).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          window.open(json.data);
        }
      }).catch((res) => {

      });
    }
  },
  mounted () {
    this.doSearch();
  }
};
</script>

<style>

</style>
